"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataWithCacheRace = exports.getDataWithCache = exports.EXPIRED_TYPE = void 0;
const rxjs_1 = require("rxjs");
const LocalStorage_1 = require("../Storage/LocalStorage");
const operators_1 = require("rxjs/operators");
const Error_1 = require("../error/Error");
const dataRetrive_1 = require("../dataRetrive");
var EXPIRED_TYPE;
(function (EXPIRED_TYPE) {
    EXPIRED_TYPE["NEVER"] = "never";
    EXPIRED_TYPE["NONE"] = "none";
})(EXPIRED_TYPE || (exports.EXPIRED_TYPE = EXPIRED_TYPE = {}));
function requestData(param) {
    const [cacheObservable, memoryObservable, networkObservable] = getDataCacheRequestObservable(param);
    return (0, rxjs_1.merge)((0, rxjs_1.race)(cacheObservable, memoryObservable), networkObservable);
}
function getDataCacheRequestObservable(param) {
    const getDataFromCache = (0, rxjs_1.of)(0)
        .pipe((0, operators_1.flatMap)(() => {
        let requestCacheTimeStart = Date.now();
        return (0, LocalStorage_1.getLocalStorage)()
            .getObject(param.dataKey)
            .pipe((0, operators_1.tap)(() => {
            const eventName = `${param.dataKey}_local_interval`;
            (0, dataRetrive_1.getTradeDependencyInstance)().log(dataRetrive_1.LogLevel.LEVEL_INFO, eventName, `request time interval ${Date.now() - requestCacheTimeStart}`);
        }));
    }))
        .pipe((0, operators_1.map)((lastResult) => {
        if (lastResult) {
            if (lastResult.keyId === undefined || lastResult.keyId === param.keyId) {
                if (param.expireTime === EXPIRED_TYPE.NONE) {
                    return undefined;
                }
                return lastResult.data;
            }
        }
        return undefined;
    }))
        .pipe((0, operators_1.flatMap)((result) => {
        ///> record all local cache request
        const eventName = `${param.dataKey}_local`;
        (0, dataRetrive_1.getTradeDependencyInstance)().log(dataRetrive_1.LogLevel.LEVEL_INFO, eventName, `cacheResult: ${result ? 1 : 0}`);
        if (!result) {
            return rxjs_1.NEVER;
        }
        return (0, rxjs_1.of)(result);
    }));
    const getDataFromMemory = (0, rxjs_1.of)(0).pipe((0, operators_1.flatMap)(() => {
        if (param.memoryCache) {
            const result = param.memoryCache();
            if ((0, rxjs_1.isObservable)(result)) {
                return result;
            }
            return (0, rxjs_1.of)(result);
        }
        else {
            return rxjs_1.NEVER;
        }
    }));
    const networkObservable = (0, rxjs_1.of)(0)
        .pipe((0, operators_1.flatMap)(() => {
        let startRequestTime = Date.now();
        let requestCount = 0;
        return param.refresh().pipe((0, operators_1.tap)(() => {
            if (requestCount === 0) {
                requestCount++;
                const eventName = `${param.dataKey}_network`;
                (0, dataRetrive_1.getTradeDependencyInstance)().log(dataRetrive_1.LogLevel.LEVEL_INFO, eventName, `request time cost: ${Date.now() - startRequestTime}`);
            }
        }));
    }))
        .pipe((0, operators_1.tap)((result) => {
        (0, LocalStorage_1.getLocalStorage)().setObject(param.dataKey, {
            keyId: param.keyId,
            timestamp: new Date().getTime(),
            data: result,
        });
    }));
    return [getDataFromCache, getDataFromMemory, networkObservable];
}
/**
 * 获取缓存数据并异步刷新
 * @param param
 */
function getDataWithCache(param) {
    if (!param || !param.dataKey || !param.refresh) {
        throw Error_1.ErrorGenerate.generateError(undefined, "Invalid param");
    }
    return requestData(param);
}
exports.getDataWithCache = getDataWithCache;
/**
 * 获取内存/文件缓存/网络数据 优先返回后关闭数据流
 * @param param
 */
function getDataWithCacheRace(param) {
    const [cacheObservable, memoryObservable, networkObservable] = getDataCacheRequestObservable(param);
    return (0, rxjs_1.race)(cacheObservable, memoryObservable, networkObservable);
}
exports.getDataWithCacheRace = getDataWithCacheRace;
